import { HipaaLogo } from "~/icons";
import { ROUTES } from "~/router/routes";
import { ArrowIcon } from "~/shared/components/icons/ArrowIcon";
import type { FormRegistryEntry } from "~/shared/utils/formRegistry";
import { validateStepOrder } from "~/shared/utils/formRegistry";
import {
  FormActionButtonsContainer,
  FormContentContainer,
  FullNameForm,
  HealthConditionsForm,
  LocationForm,
  PhoneForm,
  PrimaryInsuranceProviderForm,
  ReferredByForm,
  SecondaryInsuranceProviderForm,
} from "../components/SignUp";
import { AdminEmailForm } from "../components/SignUp/Forms/AdminEmailForm";
import { AdminOtherInfoForm } from "../components/SignUp/Forms/AdminOtherInfoForm";
import { SignUpFlowShell } from "../components/SignUp/SignUpFlowShell";
import { BACKOFFICE_FLOW_VERSION } from "../utils/flowVersion";

const formSteps: FormRegistryEntry[] = [
  {
    component: HealthConditionsForm,
    id: "health_conditions",
    writes: ["conditions"],
    reads: [],
  },
  {
    component: AdminOtherInfoForm,
    id: "other_info",
    writes: ["extraInformation"],
    reads: [],
  },
  {
    component: FullNameForm,
    id: "full_name",
    writes: ["firstName", "lastName"],
    reads: [],
  },
  {
    component: PrimaryInsuranceProviderForm,
    id: "primary_insurance",
    writes: ["primaryInsurance"],
    reads: ["state"],
  },
  {
    component: SecondaryInsuranceProviderForm,
    id: "secondary_insurance",
    writes: ["secondaryInsurance"],
    reads: ["state"],
  },
  {
    component: LocationForm,
    id: "location",
    writes: ["state", "visitType", "preferredOfficeVisit"],
    reads: [],
  },
  {
    component: AdminEmailForm,
    id: "email",
    writes: ["email"],
    reads: [],
  },
  {
    component: PhoneForm,
    id: "phone",
    writes: ["phone"],
    reads: [],
  },
  {
    component: ReferredByForm,
    id: "referred_by",
    writes: ["referral", "otherReferral"],
    reads: [],
  },
];

if (import.meta.env.DEV) {
  const warnings = validateStepOrder(formSteps);
  if (warnings.length > 0) {
    console.warn("[FormRegistry] Step order warnings:", warnings);
  }
}

export const AdminSignUpScreen = () => (
  <SignUpFlowShell
    formSteps={formSteps}
    flowVersion={BACKOFFICE_FLOW_VERSION}
    terminalRoute={ROUTES.adminProviderSelection}
    renderIntro={(onStart) => (
      <div className="rounded-lg shadow-xl">
        <FormContentContainer>
          <HipaaLogo className="size-16 self-center sm:size-20" />
          <img src="/images/sign-up-family.png" className="rounded-lg" alt="" />
          <h1 className="font-display sm:text-large-title text-2xl">
            Embark on the journey to a healthier, happier you.
          </h1>
          <span className="font-roboto text-base sm:text-lg">
            In the upcoming moments, we'll guide you in discovering the ideal
            dietitian tailored to your individualized needs, lifestyle, and
            objectives.
          </span>
        </FormContentContainer>
        <FormActionButtonsContainer>
          <button
            className="flex cursor-pointer items-center justify-end gap-2 bg-green-300 px-6 py-4 font-medium"
            onClick={onStart}
          >
            <span>GET STARTED</span>
            <ArrowIcon direction="left" />
          </button>
        </FormActionButtonsContainer>
      </div>
    )}
  />
);
